import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';

import { logout } from 'scripts/redux/actions/user';

import { signupMinorUrl } from 'src/utils/pageUrls';

@connect(null, { logout, replace })
export default class LogoutAndSignupMinor extends Component {
  static propTypes = {
    logout: PropTypes.func,
    replace: PropTypes.func,
  };

  UNSAFE_componentWillMount() {
    if (CLIENT) {
      this.props.logout();
      this.props.replace(signupMinorUrl());
    }
  }

  render() {
    return null;
  }
}
